import { createContext } from 'react';

export default createContext({
  hideHeader: false,
  setHideHeader: () => {},
})
